(function () {
  'use strict';

  var root = document.getElementById('wsc-widget');
  if (!root) return;

  if (root.parentElement && root.parentElement !== document.body) {
    document.body.appendChild(root);
  }

  var whatsappNumber = (root.getAttribute('data-whatsapp') || '').replace(/\D/g, '');
  var initialized = false;
  var isOpen = false;
  var selectedTopic = null;
  var selectedLabel = '';

  var els = {};
  var focusable =
    'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function $(id) {
    return document.getElementById(id);
  }

  function cache() {
    els.launcher = $('wsc-launcher');
    els.overlay = $('wsc-overlay');
    els.panel = $('wsc-panel');
    els.close = $('wsc-close');
    els.form = $('wsc-form');
    els.orderId = $('wsc-order-id');
    els.phone = $('wsc-phone');
    els.topics = $('wsc-topics');
    els.errOrder = $('wsc-err-order');
    els.errPhone = $('wsc-err-phone');
    els.errTopic = $('wsc-err-topic');
    els.formError = $('wsc-form-error');
  }

  function init() {
    if (initialized) return;
    initialized = true;
    cache();

    els.overlay.addEventListener('click', closePanel);
    els.close.addEventListener('click', closePanel);

    els.topics.addEventListener('click', function (e) {
      var btn = e.target.closest('.wsc-topic');
      if (!btn) return;
      selectedTopic = btn.getAttribute('data-topic');
      selectedLabel = btn.getAttribute('data-label') || selectedTopic;
      root.querySelectorAll('.wsc-topic').forEach(function (t) {
        var on = t === btn;
        t.classList.toggle('wsc-topic--on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      hideErr(els.errTopic);
    });

    els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (validate()) openWhatsApp();
    });

    document.addEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closePanel();
      return;
    }
    if (e.key === 'Tab') trapFocus(e);
  }

  function trapFocus(e) {
    var nodes = els.panel.querySelectorAll(focusable);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openPanel() {
    init();
    isOpen = true;
    els.launcher.setAttribute('aria-expanded', 'true');
    els.overlay.hidden = false;
    els.panel.hidden = false;
    requestAnimationFrame(function () {
      els.panel.classList.add('wsc-panel--open');
    });
    els.orderId.focus();
  }

  function closePanel() {
    if (!initialized) return;
    isOpen = false;
    els.launcher.setAttribute('aria-expanded', 'false');
    els.panel.classList.remove('wsc-panel--open');
    setTimeout(function () {
      els.panel.hidden = true;
      els.overlay.hidden = true;
    }, 280);
    els.launcher.focus();
  }

  function showErr(el, msg, input) {
    if (el) {
      el.textContent = msg;
      el.hidden = false;
    }
    if (input) input.classList.add('wsc-input--error');
  }

  function hideErr(el) {
    if (el) el.hidden = true;
  }

  function clearErrors() {
    hideErr(els.errOrder);
    hideErr(els.errPhone);
    hideErr(els.errTopic);
    if (els.formError) els.formError.hidden = true;
    els.orderId.classList.remove('wsc-input--error');
    els.phone.classList.remove('wsc-input--error');
  }

  function validate() {
    clearErrors();
    var ok = true;

    var orderId = els.orderId.value.trim();
    if (!orderId) {
      showErr(els.errOrder, 'Order ID is required', els.orderId);
      ok = false;
    }

    var phone = els.phone.value.replace(/\D/g, '');
    if (!/^\d{10,15}$/.test(phone)) {
      showErr(els.errPhone, 'Enter 10–15 digit phone number', els.phone);
      ok = false;
    }

    if (!selectedTopic) {
      if (els.errTopic) els.errTopic.hidden = false;
      ok = false;
    }

    if (!ok && els.formError) {
      els.formError.textContent = 'Please complete all fields';
      els.formError.hidden = false;
    }

    return ok;
  }

  function buildMessage() {
    var phone = els.phone.value.replace(/\D/g, '');
    var lines = [
      'Hello, I need support.',
      '',
      'Issue: ' + selectedLabel,
      'Order ID: ' + els.orderId.value.trim(),
      'Phone number: ' + phone,
      '',
      'Sent from website support widget'
    ];
    return lines.join('\n');
  }

  function openWhatsApp() {
    if (!whatsappNumber) {
      if (els.formError) {
        els.formError.textContent = 'WhatsApp number not configured in theme';
        els.formError.hidden = false;
      }
      return;
    }
    var url = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(buildMessage());
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  var launcher = $('wsc-launcher');
  if (launcher) {
    launcher.addEventListener('click', function () {
      init();
      if (!isOpen) openPanel();
    });
  }
})();
